import { Box, Typography, TextField, Button, Alert } from "@mui/material";
import { Formik, Form, Field } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import { saveCurrentUser } from "../../config/config";
import TimezoneSelector from "./TimezoneSelector";

const UserInfoSchema = Yup.object().shape({
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  timezone: Yup.string().required("Timezone is required"),
});

const UserInfo = ({ user }) => {
  const [saveResult, setSaveResult] = useState(null);

  const handleSave = async (values) => {
    try {
      const response = await saveCurrentUser(values);
      
      if (response.status === 200) {
        const updatedUser = { ...user, ...values };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        setSaveResult({ success: true, message: response.data.message });
      } else {
        setSaveResult({ success: false, message: response.message});
      }
    } catch (error) {
      setSaveResult({ success: false, message: "An error occurred while updating user information" });
    }
  };

  return (
    <Box sx={{ marginBottom: 4 }}>
      <Typography variant="h6" sx={{ marginBottom: 2 }}>
        User Information
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: 2 }}>
        <strong>Email:</strong> {user.email}
      </Typography>
      <Formik
        initialValues={{
          firstName: user.firstName || "",
          lastName: user.lastName || "",
          timezone: user.timezone || "",
        }}
        validationSchema={UserInfoSchema}
        onSubmit={handleSave}
      >
        {({ errors, touched, setFieldValue }) => (
          <Form>
            <Box sx={{ marginBottom: 2 }}>
              <Field
                as={TextField}
                label="First Name"
                name="firstName"
                fullWidth
                error={touched.firstName && Boolean(errors.firstName)}
                helperText={touched.firstName && errors.firstName}
              />
            </Box>
            <Box sx={{ marginBottom: 2 }}>
              <Field
                as={TextField}
                label="Last Name"
                name="lastName"
                fullWidth
                error={touched.lastName && Boolean(errors.lastName)}
                helperText={touched.lastName && errors.lastName}
              />
            </Box>
            <Box sx={{ marginBottom: 2 }}>
              <TimezoneSelector
                userTimezone={user.timezone}
                onTimezoneChange={(timezone) => setFieldValue("timezone", timezone)}
              />
            </Box>
            {touched.timezone && errors.timezone && (
              <Typography color="error" variant="caption">
                {errors.timezone}
              </Typography>
            )}
            <Button
              variant="contained"
              color="primary"
              type="submit"
              sx={{ marginTop: 2 }}
            >
              Save
            </Button>
            {saveResult && (
              <Alert
                severity={saveResult.success ? "success" : "error"}
                sx={{ marginTop: 2 }}
              >
                {saveResult.message}
              </Alert>
            )}
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default UserInfo;
